import React, {useEffect, useState} from "react";
import { Document, Page } from 'react-pdf/dist/esm/entry.webpack';
import { withStyles } from '@material-ui/core/styles';
import { InView } from 'react-intersection-observer';
import JoditEditor from "jodit-react";
import Notification from "../../../components/Notification";
import {findDocumentoClienteAssinadoPlugSign, findDocumentoClienteAssinaturaByIdPlugsign } from "../../../services/DocumentoService";


const styles = {
    pdfContainer: {
        display: 'flex', 
        alignContent: 'center', 
        justifyContent: 'center', 
        padding: '20px 0 20px 0',
        flex:'1'
    },
    page: {
        margin: '10px 15px'
    }
};

const DocumentPreview = (props) => {
    const {classes, onPageChange} = props;
    const [pdfContent, setPdfContent] = useState('');
    const [htmlContent, setHtmlContent] = useState('');
    const [numPages, setNumPages] = useState(null);
    const [notificationOptions, setNotificationOptions] = useState({
        openNotification: false,
        notificationVariant: '',
        notificationMessage: ''
    });

    useEffect(() => {
        getDocumentBase64();
    }, []);
    const decodeBase64Utf8Html = (base64) => {
    const binary = atob(base64);
    const isPdf = binary.startsWith('%PDF')
    if(isPdf){
        return ""
    }
    const bytes = Uint8Array.from(binary, (c) => c.charCodeAt(0));
    return new TextDecoder('utf-8').decode(bytes);
  }
    const getDocumentBase64 = async () => {
        const {isTelaPaciente,modeloDocumento}=props
        try {
            let documentBase64=""
            if(isTelaPaciente){
                
                    const base64 = modeloDocumento.idExternoAssinadoPlugsign ? await findDocumentoClienteAssinadoPlugSign(modeloDocumento.idExternoAssinadoPlugsign) : await findDocumentoClienteAssinaturaByIdPlugsign(modeloDocumento.id);
                const documentHtmlBase64 = decodeBase64Utf8Html(base64);
                
                if(documentHtmlBase64.length > 0){
                    documentBase64 = documentHtmlBase64
                    setHtmlContent(documentBase64)
                    return
                }
                    documentBase64 = `data:application/pdf;base64,${base64}`;

            }else{
                const {documentoStore, modeloDocumento} = props;
               const base64 = await documentoStore.imprimirDocumento({id: modeloDocumento.id});
               documentBase64 = `data:${base64}`;
            } 
            setPdfContent(documentBase64);
        } catch (error) {
            console.log(error.message);
        }
    };

    const onLoadSuccess = ({ numPages }) => {
        setNotificationOptions({
            openNotification: true,
            notificationMessage: 'Documento carregado com sucesso!',
            notificationVariant: 'success'
        });
        setNumPages(numPages);
        onPageChange(1, numPages);
    };

    const onLoadError = () => {
        setNotificationOptions({
            openNotification: true,
            notificationMessage: 'Falha ao carregar documento',
            notificationVariant: 'error'
        });
    }

    const handleCloseNotification = () => {
        setNotificationOptions({
            openNotification: false,
            notificationMessage: '',
            notificationVariant: ''
        });
    }

    const changePage = (inView, entry, pageNumber) => {
        if (inView && entry.intersectionRatio > 0.7 && entry.intersectionRatio < 1) {
            onPageChange(pageNumber, numPages);
        }
    }

    return (
        <div className={classes.pdfContainer}>
            {pdfContent && (<Document 
                file={pdfContent}
                onLoadError={onLoadError}
                onLoadSuccess={onLoadSuccess}
            >
                {numPages > 0 && Array.from(
                    new Array(numPages),
                    (item, index) => (
                    <InView 
                    onChange={(inView, entry) => changePage(inView, entry, index + 1)} 
                    key={index + 1}
                    threshold={0.7}
                    className={classes.page}
                    >
                        <Page 
                        pageNumber={index + 1}
                        as="div" 
                        />
                    </InView>
                    )
                    )}
            </Document>
                )}
            {htmlContent && (
            <div style={{width:'100%'}}>
                <JoditEditor
                disabled={true}
                value={htmlContent}
                style={{ flex: 1 }}
                config={{
                readonly: true, 
                toolbar: false,
                minHeight:'300px',
                width: '100%',
                flex:'1'
                }}
                />
            </div>  
          )}
            {notificationOptions.openNotification && 
                <Notification 
                    close={handleCloseNotification}
                    isOpen={notificationOptions.openNotification}
                    variant={notificationOptions.notificationVariant}
                    message={notificationOptions.notificationMessage}
                />
            }
        </div>
    );
};

export default withStyles(styles)(DocumentPreview);
